import './ShippingMain.css'

import { Button, Table } from 'react-bootstrap'
import React, { useEffect, useState } from 'react'

import CSVImport from './CSVImport'
import NewParcel from './NewParcel'
import ShipmentParcelList from './ShipmentParcelList'
import { axiosWithPostUrlEncoded as axios } from 'config/axios.js'
import format from 'date-fns/format'
import { getShipment } from 'api/ispyb.js'
import parse from 'date-fns/parse'
import { useSelector } from 'react-redux'
import { withRouter } from 'react-router'

const ShippingMain = ({ match }) => {
  const user = useSelector(state => state.user)
  const proposals = useSelector(state => state.proposalInfo.data.map(d => d.proposal).flat())
  const proposalName = proposals[0].code + proposals[0].number

  const [shipment, setShipment] = useState(null)

  const [showAddParcel, setShowAddParcel] = useState(false)
  const [showCsvImport, setShowCsvImport] = useState(false)
  const [showParcelList, setShowParcelList] = useState(false)

  const [shouldReload, setShouldReload] = useState(0)

  const shippingId = match.params.shippingId
  useEffect(() => {
    axios.get(getShipment(user, proposalName, shippingId)).then(({ data: shippingData }) => setShipment(shippingData))
  }, [proposalName, user, shippingId, shouldReload])

  function showComponent(name) {
    switch (name) {
      case 'showAddParcel':
        setShowAddParcel(!showAddParcel)
        break
      case 'showCsvImport':
        setShowCsvImport(!showCsvImport)
        break
      case 'showParcelList':
        setShowParcelList(!showParcelList)
        break
      default:
        null
    }
  }

  return (
    <>
      <div>
        <Table className="shippingmaintable" border="3">
          <tbody>
            <tr>
              <td>Name</td>
              <td>{shipment?.shippingName}</td>
            </tr>
            <tr>
              <td>Beamline</td>
              <td>{shipment?.sessions[0].beamlineName}</td>
            </tr>
            <tr>
              <td>Date</td>
              <td>
                {shipment &&
                  format(parse(shipment.sessions[0].startDate, 'MMM d, yyyy h:mm:ss aaa', new Date()), 'dd-MM-yyyy')}
              </td>
            </tr>
            <tr>
              <td>Status</td>
              <td>
                <kbd>{shipment?.shippingStatus}</kbd>
              </td>
            </tr>
            <tr>
              <td>Comments</td>
              <td>
                <textarea rows="2" disabled="" value={shipment?.comments} />
              </td>
            </tr>
            <tr>
              <td>From</td>
              <td>{shipment?.sendingLabContactVO.cardName}</td>
            </tr>
            <tr>
              <td>Return address</td>
              <td>{shipment?.returnLabContactVO.cardName}</td>
            </tr>
          </tbody>
        </Table>
      </div>
      {/* Tatiana ISABET requested to comment this 20210408 <div>
          <Table>
            <tbody>
              <tr />
              <tr>
                <td>Courier company</td>
                <td>{shipment?.returnLabContactVO.defaultCourrierCompany}</td>
              </tr>
              <tr>
                <td>Billing Reference</td>
                <td>{shipment?.returnLabContactVO.billingReference}</td>
              </tr>
            </tbody>
          </Table>
        </div> */}
      {/* <div>
          <Table>
            <tbody>
              <tr>
                <td>Allowed Reimb. parcels</td>
                <td />
              </tr>
              <tr>
                <td>Fedex Reference</td>
                <td>
                  <kbd>
                    {shipment?.sessions[0].code}-{shipment?.sessions[0].number}/{shipment?.sessions[0].beamlineName}/
                    {shipment &&
                      format(
                        parse(shipment?.sessions[0].startDate, 'MMM d, yyyy h:mm:ss aaa', new Date()),
                        'dd-MM-yyyy'
                      )}
                  </kbd>
                </td>
              </tr>
            </tbody>
          </Table>
        </div> */}
      <hr />
      <div className="center-div">
        <Button bsStyle="primary" onClick={() => showComponent('showAddParcel')}>
          Add Parcel
        </Button>
        <Button bsStyle="primary" onClick={() => showComponent('showCsvImport')}>
          Import from CSV or Excel
        </Button>
        <Button bsStyle="primary" onClick={() => showComponent('showParcelList')}>
          Show list of parcels
        </Button>
      </div>
      {showAddParcel && shipment ? (
        <NewParcel
          shippingId={shippingId}
          proposalName={proposalName}
          onReload={() => setShouldReload(prev => prev + 1)}
          handleClose={() => setShowAddParcel(false)}
        />
      ) : null}
      {showCsvImport && shipment ? (
        <CSVImport
          shippingId={shippingId}
          proposalName={proposalName}
          onReload={() => setShouldReload(prev => prev + 1)}
        />
      ) : null}
      {showParcelList && shipment ? <ShipmentParcelList shipment={shipment} /> : null}
    </>
  )
}

export default withRouter(ShippingMain)
